import React from "react";
import Heading from "../../components/atoms/Heading/Heading";
import Header from "./header";
import styles from "./Login.module.scss";
import LoginForm from "./LoginForm";
const Login = () => {
  return (
    <>
      <Header />
      <div className="container bg-white login">
        <div className={`packsWrapper pt-64 ${styles["login-full-height"]}`}>
          <div className={`${styles["business-detail"]}`}>
            <div className={`${styles["move-center"]}`}>
              <img
                src="https://assets.airtel.in/static-assets/LCO/svg/airtel-swoosh.svg"
                width={200}
                height={200}
                alt="logo_image"
                className={styles.logo}
              />
              <Heading variant="h2-red" text="SIGN IN" />
              <div className="form">
                <div className="card">
                  <LoginForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
